module.exports = __webpack_public_path__ + "img/pro_dcmb.c959d00b.svg";